import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  root: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 8px',
  },
  small: {
    width: 8,
    minHeight: 8,
    height: 8,
    minWidth: 8,
  },
  medium: {
    height: 16,
    width: 16,
    minHeight: 16,
    minWidth: 16,
  },
  large: {
    height: 32,
    width: 32,
    minHeight: 32,
    minWidth: 32,
  },
  spinner: {
    stroke: 'currentColor',
    transform: 'translateZ(0)',
    animation: '$spinner-fade 400ms ease-in, $spinner-spin 1s infinite linear',
    animationFillMode: 'forwards',
    borderRadius: '50%',
    boxSizing: 'border-box',
    borderTop: '3px solid #0F0F2240',
    borderRight: '3px solid #0F0F2240',
    borderBottom: '3px solid #0F0F2240',
    borderLeft: '3px solid #fff',
  },
  '@keyframes spinner-fade': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },

  '@keyframes spinner-spin': {
    from: { transform: 'rotate(0)' },
    to: { transform: 'rotate(360deg)' },
  },
}));

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
};
function LoadingSpinner({
  className,
  size = 'medium',
}: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <div className={classNames(className, classes.root)}>
      <span
        className={classNames(classes.spinner, { [classes[size]]: size })}
      />
    </div>
  );
}

export default LoadingSpinner;
